import { FunctionComponent } from "react";
import ConfirmForgotPasswordForm from "src/components/forms/auth/ConfirmForgotPasswordForm";
import { PageContainer, PageTitle } from "src/components/generic";
import TopNav from "src/components/navigation/TopNav";

const ConfirmForgotPassword: FunctionComponent = () => (
    <PageContainer>
        <div className="px-3">
            <TopNav />
        </div>
        <div>
            <PageTitle title="Confirm Forgot Password" />

            <ConfirmForgotPasswordForm />
        </div>
    </PageContainer>
);

export default ConfirmForgotPassword;